var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"label":"Discount Amount","type":"number","value":_vm.amount,"prefix":"₱","outlined":"","dense":"","hide-details":""},on:{"input":_vm.amountChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }